// Pure GST totals math for document forms (no React) — unit-testable and shared.

function lineBase(it, inclusive) {
  const qty = Number(it.quantity || 0);
  const rateInput = Number(it.rate || 0);
  const gstRate = Number(it.gst_rate || 0);
  const baseRate = inclusive && gstRate ? rateInput / (1 + gstRate / 100) : rateInput;
  const gross = qty * baseRate;
  const disc = gross * Number(it.discount_pct || 0) / 100;
  return { gross, pre: gross - disc, gstRate };
}

export function resolveDestState({ form, party, partyMode, companyState }) {
  const inlineStateCode = form.party_inline?.state_code || "";
  return form.place_of_supply_state_code || party?.state_code || (partyMode === "urp" ? inlineStateCode : "") || companyState;
}

export function computeDocTotals({ form, destState, companyState, showAdvance }) {
  const isInterState = Boolean(destState) && destState !== companyState;
  const inclusive = !!form.rate_includes_gst;
  const lines = form.items.map(it => lineBase(it, inclusive));
  const subtotal = lines.reduce((s, l) => s + l.gross, 0);
  const preTaxable = lines.reduce((s, l) => s + l.pre, 0);

  const dt = form.extra_discount_type || "amount";
  const dv = Number(form.extra_discount_value || 0);
  const extraAmt = Math.min(Math.max(dt === "pct" ? (preTaxable * dv) / 100 : dv, 0), preTaxable);
  const totalTaxable = preTaxable - extraAmt;

  let cgst = 0, sgst = 0, igst = 0;
  for (const l of lines) {
    const lineExtra = preTaxable > 0 ? extraAmt * (l.pre / preTaxable) : 0;
    const taxable = l.pre - lineExtra;
    if (isInterState) igst += taxable * l.gstRate / 100;
    else { cgst += taxable * (l.gstRate / 2) / 100; sgst += taxable * (l.gstRate / 2) / 100; }
  }
  const grandPreAdvance = totalTaxable + cgst + sgst + igst;
  const grandRounded = Math.round(grandPreAdvance);
  const roundOff = +(grandRounded - grandPreAdvance).toFixed(2);
  const adv = Number(form.advance_amount || 0);
  const showAdvDeduct = !!showAdvance && adv > 0;
  const grand = showAdvDeduct ? Math.max(0, grandRounded - adv) : grandRounded;
  return { subtotal, lineDiscount: subtotal - preTaxable, extraDiscount: extraAmt, totalTaxable, cgst, sgst, igst,
    grandPreAdvance: grandRounded, roundOff, advanceApplied: showAdvDeduct ? adv : 0, grand, isInterState, destState };
}
